import React, {Component} from 'react';
import {PATH_TO_IMAGES} from 'config';

export default class LoadingBox extends Component {
    render() {
        return (
            <div className="loading-box">
                <div className="loading-table">
                    <div className="loading-cell">
                        <div className="mb20">
                            <img src={`${PATH_TO_IMAGES}/loader.gif`} alt="" />
                        </div>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}
